import {userUnLock, publicPoolTakeUser, userMoveOut, userMoveOutBatch, setGuestDistribution} from '@/api/custome';
export default{
  // 客户状态：1公客池  2私客池  3无效池  4黑名单  5蓄客池
  methods: {
    // 黑名单客户【黑名单客户只能移出到公客池】
    handleBlackMove (row) {
      this.$confirm('确认移出该客户至公客池？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        this.handleMoveDatabase(row.id);
      }).catch(e => {})
    },
    // 批量移出黑名单客户
    handleBlackMoveBatch (rows) {
      this.$confirm('确认移出选中客户至公客池？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        const ids = rows.map(v => v.id).join(',');
        this.handleMoveDatabase(ids);
      }).catch(e => {})
    },
    // 无效池客户【无效池客户移出可选择移出位置到公客池/经纪人】
    handleInvilidMove (rows) {
      this.isOpenMoveOut = true;
      this.moveOutType = 'invalid';
      this.userMoveoutObj = rows;
    },
    async handleMoveDatabase (ids, admin_id) {
      try {
        const params = {ids};
        if (admin_id) {
          params.admin_id = admin_id;
        }
        const res = await (`${ids}`.indexOf(',') > 0 ? userMoveOutBatch : userMoveOut)(params);
        this.$message.success('移出成功');
        this.clearMoveInfo();
        this.handleOperateReload?.(); 
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    // 蓄客池分配
    handleGuestDistribe (rows) {
      this.isOpenMoveOut = true;
      this.moveOutType = 'guest';
      this.userMoveoutObj = rows;
    },
    handleDistribeDatabase (ids, admin_id) {
      try {
        setGuestDistribution({
          ids: ids,
          admin_id: `${admin_id}`
        }).then(res=>{
          if (res.errCode == 0){
            this.$message.success('分配成功');
            this.clearMoveInfo();
            this.handleOperateReload?.('guest');
          } else{
            this.$message.error(res.errMsg || '操作失败，请重试');
          }
        });
      } catch (error) {
        this.$message.error(error.errMsg || '操作失败，请重试');
      }
    },
    // 移出/分配确认回调:adminId:undefined为公客池，相反则为对应的私客池
    handleMoveoutConfirm (adminId) {
      const ids = this.userMoveoutObj.map(v => v.id).join(',');
      if (this.moveOutType === 'invalid') {
        this.handleMoveDatabase(ids, adminId);
      } else if (this.moveOutType === 'guest') {
        this.handleDistribeDatabase(ids, adminId);
      }
    },
    // 清除移出/分配数据缓存
    clearMoveInfo () {
      this.userMoveoutObj = [];
      this.isOpenMoveOut = false;
      this.moveOutType = '';
    },
    // 锁定客户-解锁操作
    handleUnLock (row) {
      this.$confirm('解锁后，该客户将受到公客池回收规则的限制，请确认是否解锁', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          await userUnLock({
            customer_id: row.id
          });
          this.$message.success('解锁成功');
          this.handleOperateReload?.();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    },
    // 公客池-抢客操作
    handleTakeCustome (row) {
      this.$confirm('确认领取该客户？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          await publicPoolTakeUser(row.id, {
            customer_id: row.id
          });
          this.$message.success('抢客成功');
          this.handleOperateReload?.();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    },
    // 新增客户-校验手机错误处理
    handleCheckError (res, mobile) {
      if (res.allow_take_from_public) {
        this.dealTabkeFromPublic(res);
      } else if (res.allow_collision) {
        this.dealCollision(res, mobile);
      } else if (res.allow_distribution) {
        this.dealDistribution(res);
      } else if (res.allow_move_out) {
        if (res.status === 3) {
          this.dealMoveOut(res);
        } else {
          this.dealBlackMoveOut(res);
        }
      } else {
        this.$message.error(res.message);
      }
    },
    // 添加客户-领取公客池客户
    async dealTabkeFromPublic (res) {
      const hasPermission = await this.$store.dispatch('user/hasPermission', 'customer.public.list.loot');
      this.$confirm(`${res.message}${hasPermission ? ',您可以领取该客户！' : ''}`, '操作提示', {
        confirmButtonText: '领取客户',
        showConfirmButton: hasPermission,
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          await publicPoolTakeUser(res.id, {
            customer_id: res.id
          });
          this.$message.success('抢客成功');
          this.handleOperateReload?.();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {});
    },
    // 添加客户-申请撞客
    async dealCollision (res, mobile) {
      const hasPermission = await this.$store.dispatch('user/hasPermission', 'customer.collision');
      this.$confirm(`${res.message}${hasPermission ? ',您可以申请撞客！' : ''}`, '操作提示', {
        confirmButtonText: '申请撞客',
        showCancelButton: hasPermission,
        customClass: 'custom-delete-dialog',
      }).then(_ => {
        this.$EventBus.$emit(this.emitName, {category: 'operate', params: {
          operateType: 'hit',
          baseInfo: {
            customer_name: res.name,
            customer_tel: mobile,
            customer_id: res.id
          }
        }})
      }).catch(e => {});
    },
    // 新增客户-申请分配
    async dealDistribution (res) {
      const hasPermission = await this.$store.dispatch('user/hasPermission', 'customer.new.list.distribute');
      this.$confirm(`${res.message}${hasPermission ? ',您可以申请分配！' : ''}`, '操作提示', {
        confirmButtonText: '申请分配',
        showConfirmButton: hasPermission,
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        this.handleGuestDistribe([res]);
      }).catch(e => {});
    },
    // 新增客户-无效池申请转出
    async dealMoveOut (res) {
      const hasPermission = await this.$store.dispatch('user/hasPermission', 'customer.invalid.list.move');
      this.$confirm(`${res.message}${hasPermission ? ',您可以申请转出！' : ''}`, '操作提示', {
        confirmButtonText: '申请转出',
        showConfirmButton: hasPermission,
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        this.handleInvilidMove([res]);
      }).catch(e => {});
    },
    // 新增客户-黑名单申请转出
    async dealBlackMoveOut (res) {
      const hasPermission = await this.$store.dispatch('user/hasPermission', 'customer.black.list.move');
      this.$confirm(`${res.message}${hasPermission ? ',您可以申请转出！' : ''}`, '操作提示', {
        confirmButtonText: '申请转出',
        showConfirmButton: hasPermission,
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
         this.handleMoveDatabase(res.id);
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {});
    },
  },
}